export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";